import React from 'react';
import { CheckCircle } from 'react-feather';
import { FEATURES } from '../../../config/socialProof';

/**
 * FeatureList Component
 * Displays list of key features with checkmarks
 */
const FeatureList = () => {
    return (
        <div style={{ marginTop: '24px', marginBottom: '24px' }}>
            <h3
                style={{
                    fontSize: '18px',
                    fontWeight: 700,
                    color: '#2C3E50',
                    marginBottom: '16px',
                }}
            >
                What's Included
            </h3>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                }}
            >
                {FEATURES.map(feature => (
                    <div
                        key={feature.id}
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '12px',
                        }}
                    >
                        <CheckCircle
                            size={20}
                            color="#00A86B"
                            style={{ flexShrink: 0, marginTop: '2px' }}
                        />
                        <div>
                            <div
                                style={{
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    color: '#2C3E50',
                                    lineHeight: 1.4,
                                }}
                            >
                                {feature.title}
                            </div>
                            <div
                                style={{
                                    fontSize: '13px',
                                    color: '#546E7A',
                                    lineHeight: 1.4,
                                }}
                            >
                                {feature.description}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FeatureList;
